import { OrgInterface } from "@swivl-mono/types";

import { APIService } from "../Service/API.Service";

// LINK apps/server/src/API/S3/S3.Controller.ts
export class S3API {
  /**
   * Get a presigned S3 PUT URL for an org-scoped upload. `fileName`'s extension
   * determines the stored object's extension; the server generates the key.
   * Returns the public `fileUrl` (store this) + the `uploadUrl` to PUT the file to.
   */
  static async getSignedPutURL(orgId: number, fileName: string): Promise<{ fileUrl: string; uploadUrl: string }> {
    return APIService.Server.get<{ fileUrl: string; uploadUrl: string }>(`/s3/org/${orgId}/get-signed-url/${encodeURIComponent(fileName)}`);
  }

  static async getAnalyticsReportURLs(orgId: number): Promise<{ link: string; name: string }[]> {
    return APIService.Server.get<{ link: string; name: string }[]>(`/s3/org/${orgId}/analytics-file-list`);
    // return APIService.Notifications.get<boolean>(`/org/${orgId}/agent/${agentId}/availability`);
  }
}
